// extracted by mini-css-extract-plugin
module.exports = {"root":"TextLink-root-89aacc344fdc7bf9fd198247baafded8","icon":"TextLink-icon-7ef0d8cdf5a8ae129947df55aa96eff2"};